"use client";

import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

import { META_CONVERSION_API_EVENTS } from "@/constants/meta";

// Fires the Meta Pixel Purchase event on the Stripe checkout success page using the shared event_id from the URL. The CAPI webhook fires the same event_id server-side with the authoritative invoice.amount_paid / invoice.currency (post-tax, post-promo) AND the hashed user identifiers; Meta dedups on event_id and uses CAPI's richer payload, so we deliberately send only event_id from the browser side.
export function TrackMetaSubscriptionPurchase() {
  const searchParams = useSearchParams();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) {
      return;
    }

    const subscriptionEventId = searchParams.get("subscription_event_id");
    if (subscriptionEventId === null) {
      return;
    }

    const fbq = (window as unknown as { fbq?: (...args: unknown[]) => void })
      .fbq;
    if (typeof fbq !== "function") {
      return;
    }
    hasTracked.current = true;

    fbq(
      "track",
      META_CONVERSION_API_EVENTS.PURCHASE,
      // We dont pass any additional sub data into a purchase event, so we don't need to make a success url to big + we rely on CAPI that has all the data needed and this data will be matched by subscription event id
      {},
      { eventID: subscriptionEventId }
    );
  }, [searchParams]);

  return null;
}
